module.exports = __webpack_public_path__ + "static/media/17_r_doma_72.24_69.72.0a030d67.png";